export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70bbb023e5240bf9a305192ecf0744d5aae29784e0&name=pushAdClickData!'